(function () {
  var CLOSE_SVG =
    '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var runId = 0;
  var activeRoot = null;
  var onKeydown = null;

  function getCookie(name) {
    var decoded = decodeURIComponent(document.cookie || "");
    var parts = decoded.split(";");
    var prefix = name + "=";
    for (var i = 0; i < parts.length; i++) {
      var cookie = parts[i].replace(/^\s+/, "");
      if (cookie.indexOf(prefix) === 0) {
        return cookie.substring(prefix.length);
      }
    }
    return "";
  }

  function setCookie(name, value, hours) {
    var expires = new Date();
    expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
    document.cookie =
      name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function parseConfig() {
    var el = document.getElementById("announcement-modals-data");
    if (!el || !el.textContent.trim()) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function unlockPage() {
    document.documentElement.classList.remove("vg-announce-open");
  }

  function destroyCurrent() {
    if (onKeydown) {
      document.removeEventListener("keydown", onKeydown);
      onKeydown = null;
    }
    if (activeRoot && activeRoot.parentNode) {
      activeRoot.parentNode.removeChild(activeRoot);
    }
    activeRoot = null;
    unlockPage();
  }

  function loaderGone() {
    var el = document.getElementById("load-screen");
    if (!el) return true;
    return window.getComputedStyle(el).display === "none";
  }

  function whenLoaderGone(callback) {
    var tries = 0;
    function tick() {
      if (loaderGone() || tries++ > 40) {
        callback();
        return;
      }
      setTimeout(tick, 100);
    }
    tick();
  }

  function showChainedModals(config, myRun) {
    if (!config || !config.modals || !config.modals.length) return;
    if (myRun !== runId) return;

    var designMode =
      typeof Shopify !== "undefined" && Shopify.designMode === true;
    var cookieName = config.cookieName || "announcement_modals_seen";
    var cookieHours = config.cookieHours || 12;

    if (!designMode && cookieName && getCookie(cookieName) === "true") {
      return;
    }

    function finish() {
      if (myRun !== runId) return;
      destroyCurrent();
      if (!designMode && cookieName) {
        setCookie(cookieName, "true", cookieHours);
      }
    }

    function openModalAt(index) {
      if (myRun !== runId) return;
      if (index >= config.modals.length) {
        finish();
        return;
      }

      var item = config.modals[index];
      var html = "";
      var isText = item.type === "text";

      if (item.type === "image") {
        var desktop = item.desktop || "";
        var mobile = item.mobile || desktop;
        var alt = escapeHtml(item.alt || "");
        html =
          '<img class="desktop" src="' +
          escapeHtml(desktop) +
          '" alt="' +
          alt +
          '">' +
          '<img class="mobile" src="' +
          escapeHtml(mobile) +
          '" alt="' +
          alt +
          '">';
      } else if (isText) {
        html =
          '<div class="announcement-modal-text">' + (item.html || "") + "</div>";
      } else {
        openModalAt(index + 1);
        return;
      }

      destroyCurrent();

      var root = document.createElement("div");
      root.className = "vg-announce-modal";
      root.setAttribute("role", "dialog");
      root.setAttribute("aria-modal", "true");
      root.innerHTML =
        '<div class="vg-announce-modal__overlay"></div>' +
        '<div class="vg-announce-modal__box' +
        (isText ? " vg-announce-modal__box--text" : "") +
        '">' +
        '<button type="button" class="vg-announce-modal__close" aria-label="Bezárás">' +
        CLOSE_SVG +
        "</button>" +
        '<div class="vg-announce-modal__content">' +
        html +
        "</div></div>";

      var box = root.querySelector(".vg-announce-modal__box");
      var closeBtn = root.querySelector(".vg-announce-modal__close");
      if (isText && closeBtn) {
        var textWrap = root.querySelector(".announcement-modal-text");
        if (textWrap) textWrap.insertBefore(closeBtn, textWrap.firstChild);
      }

      var closed = false;
      function closeAndNext() {
        if (closed || myRun !== runId) return;
        closed = true;
        root.classList.remove("is-open");
        setTimeout(function () {
          if (activeRoot === root) destroyCurrent();
          openModalAt(index + 1);
        }, 220);
      }

      root.querySelector(".vg-announce-modal__overlay").addEventListener("click", closeAndNext);
      if (closeBtn) closeBtn.addEventListener("click", closeAndNext);
      onKeydown = function (event) {
        if (event.key === "Escape") closeAndNext();
      };
      document.addEventListener("keydown", onKeydown);

      document.body.appendChild(root);
      activeRoot = root;
      document.documentElement.classList.add("vg-announce-open");
      requestAnimationFrame(function () {
        root.classList.add("is-open");
        if (closeBtn) closeBtn.focus();
      });

      if (box) box.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }

    var delayMs = config.delayMs || 0;
    whenLoaderGone(function () {
      if (myRun !== runId) return;
      if (delayMs > 0) {
        setTimeout(function () {
          openModalAt(0);
        }, delayMs);
      } else {
        openModalAt(0);
      }
    });
  }

  function start() {
    var config = parseConfig();
    var myRun = ++runId;
    destroyCurrent();
    if (!config || !config.enabled) return;
    showChainedModals(config, myRun);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target || !event.target.querySelector("#announcement-modals-data")) {
      if (event.target && event.target.id === "shopify-section-announcement-modals") {
        runId++;
        destroyCurrent();
      }
      return;
    }
    start();
  });
})();
